<div class="actions" style="margin: 50px 0 60px;">
    <div *jhiHasAnyAuthority="'ROLE_ADMIN'">
        <div class="dropup">
            <button
                [disabled]="!isOneElementSelected"
                class="btn btn-default dropdown-toggle doc-buttons"
                type="button"
                id="menu1"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                Génération <span class="caret"></span>
            </button>
            <ul class="dropdown-menu multi-level" aria-labelledby="menu1">
                <li class="item" *ngFor="let doc of generateList">
                    <label
                        [title]="
                            dropdownCheckboxes.generate[doc.id].title
                                | translate
                        "
                    >
                        <input
                            (ngModelChange)="updateSelectedGeneration(doc)"
                            [(ngModel)]="
                                dropdownCheckboxes.generate[doc.id].checked
                            "
                            [ngModelOptions]="{ standalone: true }"
                            class="checkbox-trainer"
                            type="checkbox"
                            aria-label="checkbox-trainer"
                            [disabled]="
                                dropdownCheckboxes.generate[doc.id].disabled
                            "
                        />
                        <span (click)="$event.stopPropagation()">
                            {{ doc.label }}
                        </span>
                    </label>
                </li>
                <li class="divider"></li>

                <li>
                    <button
                        class="btn dropdown-item"
                        (click)="
                            downloadDocument('application/pdf', 'document.pdf')
                        "
                    >
                        Générer
                    </button>
                </li>
            </ul>
        </div>

        <div class="dropup">
            <button
                [disabled]="!isOneElementSelected"
                class="btn btn-default dropdown-toggle doc-buttons"
                type="button"
                id="menu2"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                Envoi <span class="caret"></span>
            </button>
            <div class="dropdown-menu" aria-labelledby="menu2">
                <li class="item" *ngFor="let doc of sendList">
                    <label
                        [title]="
                            dropdownCheckboxes.send[doc.id].title | translate
                        "
                    >
                        <input
                            (ngModelChange)="updateSelectedSend(doc)"
                            [(ngModel)]="
                                dropdownCheckboxes.send[doc.id].checked
                            "
                            [ngModelOptions]="{ standalone: true }"
                            class="checkbox-trainer"
                            type="checkbox"
                            aria-label="checkbox-trainer"
                            [disabled]="
                                dropdownCheckboxes.send[doc.id].disabled
                            "
                        />
                        <span (click)="$event.stopPropagation()">
                            {{ doc.label }}
                        </span>
                    </label>
                </li>
                <li class="divider"></li>
                <li>
                    <button
                        class="btn dropdown-item"
                        (click)="sendSelectedMails()"
                    >
                        Envoyer
                    </button>
                </li>
                <li class="divider"></li>
                <li>
                    <button
                        type="button"
                        class="btn dropdown-item"
                        data-toggle="modal"
                        [disabled]="!isRecapAvailable()"
                        (click)="initRecapMessageForContact()"
                        data-target="#sendTrainingSessionRecapToContactModal"
                        [title]="getRecapButtonTooltip()"
                    >
                        Envoyer Récap
                    </button>
                </li>
            </div>
        </div>

        <button
            style="margin-left: 12px;"
            class="btn btn-default doc-buttons"
            (click)="
                downloadDocument(
                    'application/pdf',
                    'emargement-vierge.pdf',
                    'ATTENDANCE_SHEET_EMPTY',
                    sessionId
                )
            "
        >
            Emargement vierge
        </button>

        <button
            style="margin-left: 12px;"
            class="btn btn-default doc-buttons"
            (click)="
                downloadDocument(
                    'application/pdf',
                    'evaluation-vierge.pdf',
                    'EVALUATION_EMPTY',
                    sessionId
                )
            "
        >
            Evaluation vierge
        </button>
    </div>
    <div style="float: right;">
        <button
            *jhiHasAnyAuthority="'ROLE_ADMIN'"
            class="btn btn-default doc-buttons"
            (click)="
                downloadDocument(
                    'text/csv',
                    'students-list.csv',
                    'STUDENTS_CSV',
                    sessionId
                )
            "
        >
            Liste des stagiaires
        </button>
        <button
            *ngIf="tsCompanies.length > 0"
            style="margin-left: 12px;"
            class="btn btn-default doc-buttons"
            (click)="copyStudentEmailToClipboard()"
        >
            <i class="fa fa-clipboard" aria-hidden="true"></i>
            {{
                'session-details.student-tab.copyStudentEmailToClipboard'
                    | translate
            }}
        </button>
    </div>
</div>

<!-- Modal -->
<div
    class="modal fade"
    id="sendTrainingSessionRecapToContactModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="sendTrainingSessionRecapToContactModal"
    aria-hidden="true"
>
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    Envoyer un récapitulatif au contact
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </h5>
            </div>
            <div class="modal-body">
                <quill-editor
                    [modules]="quillConfig"
                    [(ngModel)]="htmlEmail"
                ></quill-editor>
            </div>
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                >
                    Annuler
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="sendTrainingSessionRecapToContact()"
                    data-dismiss="modal"
                >
                    Envoyer
                </button>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/document-generation/document-generation.component.html